import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=c81e71a0&scoped=true"
import script from "./FileUpload.vue?vue&type=script&lang=ts"
export * from "./FileUpload.vue?vue&type=script&lang=ts"
import style0 from "./FileUpload.vue?vue&type=style&index=0&id=c81e71a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81e71a0",
  null
  
)

export default component.exports